import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NivelEstudioService {

  //private apiUrl = 'http://localhost:3000/api/nivelestudio';
  private apiUrl =  `${environment.apiUrl}/api/nivelestudio`; 

  constructor(private http: HttpClient) {}

  getAllNivelEstudio(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      catchError(error => {
        console.error('Error al obtener los niveles de estudio:', error);
        return throwError(() => new Error('Error al obtener los niveles de estudio'));
      })
    );
  }
}
